export const siteSettings = {
  name: "Quant Digital Markets",
  link: "https://quantdigitalmarkets.com",
  email: "support@quantdigitalmarkets.com",
  appLink: "https://app.quantdigitalmarkets.com",
};
